export default __webpack_public_path__ + "static/media/icon_covid_new.525c220d.png";